import React from 'react';
import { formatCardNumber } from './utils';
import { Heading } from '../../atoms';
import { CreditCardNumberWrapper } from './CreditCardNumber.styles';

export type CreditCardNumberProps = {
  /**
   * Credit card number
   */
  number: string;
};

const CreditCardNumber = ({ number }: CreditCardNumberProps) => (
  <CreditCardNumberWrapper>
    <Heading variant="h3" color="inherit">
      {formatCardNumber(number)}
    </Heading>
  </CreditCardNumberWrapper>
);

export default CreditCardNumber;
